module.exports = __webpack_public_path__ + "gq.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/gq.svg
// module id = 833
// module chunks = 0